// -----------------------------
// * pulmonaryOrderForm.js *
// -----------------------------

goog.provide('el8.appchart.dialog.order.pulmonary');

goog.require('el8.ptdata.model.order');
goog.require('el8.appchart.dialog.order.base');
goog.require('el8.ptdata.ptAllergies');
goog.require('el8.uiwidget.base');
goog.require('el8.service.infoField');
goog.require('el8.service.tz');
goog.require('el8.util.dom');


el8.appchart.dialog.order.pulmonary = function() {

    var container = $('#new-pulmonary-order-dialog');
    var formContainer = $('#new-pulmonary-order-form');

    // --------------------
    // Get form fields
    // --------------------
    var testCenterNotesTextarea = container.find(':input[name="testCenterNotes"]');
    var clinicalReasonTextarea = container.find(':input[name="clinicalReason"]');

    var dateForTestInputField = container.find(':input[name="dateForTest"]');
    var followUpMethodInputField = container.find(':input[name="followUpMethod"]');

    var testCenterCompanySelectField = container.find(':input[name="testCenterCompany"]');
    var testCenterSiteSelectField = container.find(':input[name="testCenterSite"]');

    var faxPrelimCheckbox = container.find(':input[name="faxPrelim"]');

    var allergiesInputField = container.find(':input[name="allergies"]');

    // --------------------
    // Initialize form fields
    // --------------------
    var dateForTestField = dateForTestInputField.el8_datePicker({},
        { infoText: 'do test on...' }
    );

    var followUpMethodField = el8.service.infoField.addInfoField({
        field : followUpMethodInputField,
        maxLength : 50,
        height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
        infoText : 'how to notify patient of results...'
    });

    var allergiesField = el8.service.infoField.addInfoField({
        field: allergiesInputField,
        height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
        infoText: 'list patient allergies...'
    });

    var testCenterNotesField = el8.service.infoField.addInfoField({
        field: testCenterNotesTextarea,
        height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
        infoText: 'notes to test center..'
    });

    var clinicalReasonField = el8.service.infoField.addInfoField({
        field: clinicalReasonTextarea,
        height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
        infoText: 'write clinical reason...'
    });

    if (el8Globals.FEATURES.BiDiLabs) {
        var reminderUserOrGroupField = el8.service.infoField.addInfoField({
            name: 'reminderUserOrGroup',
            field: container.find('.reminder-user-or-group')
        });
        var reminderDateInputField = container.find(':input[name="reminderDate"]');
        var reminderDateField = reminderDateInputField.el8_datePicker(
            {minDate: el8.service.tz.today()},
            { infoText: 'no reminder' }
        );
    }

    // ------------------------------
    // Get order object from form
    // ------------------------------
    function getOrder( model, isOnHold ) {

        var testCenterCompanyId = 1 * testCenterCompanySelectField.val();
        var testCenterSiteId = 1 * testCenterSiteSelectField.val();

        var dateForTest = dateForTestField.noInput() ? null : dateForTestField.getVal();

        var testCenterNotes = testCenterNotesField.getVal();
        var followUpMethod = followUpMethodField.getVal();
        var clinicalReason = clinicalReasonField.getVal();

        that.setPrescribingUser(model);
        model.setOnHold( isOnHold );
        model.setTestCenterCompanyId( testCenterCompanyId );
        model.setTestCenterSiteId( testCenterSiteId );

        model.setDateForTest( dateForTest );

        model.setTestCenterNotes( testCenterNotes );
        model.setFollowUpMethod( followUpMethod );
        model.setClinicalReason( clinicalReason );

        that.extractCcs(model, ccsWidget);
        that.extractTests(model, testsWidget);
        that.extractDiagnoses(model, dxWidget);

        var allergies = allergiesField.getVal();
        model.setAllergies( allergies );

        that.extractConfidentiality(model);
        that.extractShowDualCoding(model);

        // Reminders
        if (el8Globals.FEATURES.BiDiLabs) {
            that.extractReminderUserOrGroupId(model);
            model.setReminderDate(reminderDateField.noInput() ? null :  reminderDateField.getVal());
        }

        return model;
    }

    // ------------------------------
    // Populate forms
    // ------------------------------
    function populateForms(model, dialog) {

        dialog.enableForms();

        // Initialize all fields with instructions.
        dateForTestField.init();
        followUpMethodField.init();
        allergiesField.init();
        testsField.init();
        ccsField.init();
        testCenterNotesField.init();
        clinicalReasonField.init();

        initAllergies();

        if (el8Globals.FEATURES.BiDiLabs) {
            reminderUserOrGroupField.init();
            reminderDateField.init();
            $('.reminder-user-or-group', container).empty();
             _.each(el8.data.practiceUsers.getAssignees(), function(obj) {
                $('<option>').val(obj.id).text(obj.name).appendTo($('.reminder-user-or-group', container));
            });
        }

        if( model ) {
            that.populateTestCenter(model);
            that.populateDateForTest(model);

            testCenterNotesField.setVal( model.getTestCenterNotes() );
            clinicalReasonField.setVal( model.getClinicalReason() );
            followUpMethodField.setVal( model.getFollowUpMethod() );

            that.populateCcs(model, ccsWidget);
            that.populateTestNames(model, testsWidget);
            that.populateDiagnoses(model, dxWidget);

            // orderFormPulmonary specifics
            allergiesField.setVal( model.getAllergies() );

            that.populateConfidentiality(model);

            if (el8Globals.FEATURES.BiDiLabs) {
                var reminder = model.getReminder();
                if (reminder) {
                    reminderUserOrGroupField.setVal(reminder.getAssigneeId());
                    reminderDateField.setVal(reminder.getRemindDate().asString());
                }
            }

        } else {
            that.populateTestCenterFields();
        }
    }

    // Fill these in via ACMSWidget below
    var testsField = null;
    var ccsField = null;

    // --------------------
    // Initialize autocomplete functionality
    // --------------------
    var testsWidget = null;
    var ccsWidget = null;
    var dxWidget = null;


    function initWidgets() {
        var obj = that.initTestNames();
        testsWidget = obj.listeditor;
        testsField = obj.infoField;

        dxWidget = that.initDxs();

        obj = that.initCcsNames();
        ccsWidget = obj.listeditor;
        ccsField = obj.infoField;
    }

    function closeWidgets() {
        testsWidget.reset();
        ccsWidget.reset();
        dxWidget.reset();

        var $reasonField = clinicalReasonField.getInputField();
        el8.util.dom.growShrinkTextarea($reasonField, null, $reasonField.attr('height'));
    }

    function initAllergies() {
        var values = el8.ptdata.ptAllergies.all().map(
            function (a) { return a.getAllergyName(); }
        ).join(', ');
        allergiesField.setVal( values );
    }
    initAllergies();

    function initCheckboxes() {
        faxPrelimCheckbox.change( function() {
            if( $(this).is(':checked') ) {
                testCenterNotesField.setVal(
                    testCenterNotesField.getVal() + ' Fax preliminary report.'
                );
            }
        });
    }

    // ------------------------------
    // Initialize dialog and buttons
    // ------------------------------
    var titleHtml = '<div class="headerContainer">Pulmonary Test Order Form</div>'; // XSS OK -KF

    var that = el8.appchart.dialog.order.base({
        type : 'pulmonary',
        container : container,
        formContainer : formContainer,
        testCenterCompanySelectField : testCenterCompanySelectField,
        testCenterSiteSelectField : testCenterSiteSelectField,
        getOrderFn : getOrder,
        populateFormsFn : populateForms,
        closeWidgetsFn : closeWidgets,
        titleHtml : titleHtml,
        newModelFn : function newModelFn() {
            return el8.ptdata.model.order.pulmonary( {
                'model_class' : 'PulmonaryOrder',
                'isOnHold' : false,
                'documentDate' : el8.service.tz.now()
            });
        },
        dateForTestField : dateForTestField,
        dialogSpec : {
            dialogRightMargin: 575-90,
            dialogBottomMargin: 75
        }
    });

    initWidgets();
    that.initFollowUpMethod(followUpMethodField);
    initCheckboxes();
    // Needs to come last after widgets are initialized
    // so that dialog is initialized with tabOrder including widgets
    that.init();

    return that;
};
